 window.tab=function(name1,name2,name3,name4){
    $(name1).click(function(){
      var index=$(this).index();
      $(name1).addClass(name2);
      $(name1).removeClass(name3).eq(index).addClass(name3);
      $(this).removeClass(name2);
      $(name4).hide().eq(index).show();
    })
  };
 $(function(){
   tab('.list2_icon2 div','icon-list2_nav','icon-list2_focus','.tab_list');
 });

